import React from 'react';
import { Calendar } from '../components';
import TutorialVideoButton from '../components/common/TutorialVideoButton';
import './CalendarPage.css';

function CalendarPage() {
  return (
    <div className="page calendar-page">
      <Calendar />
      <TutorialVideoButton
        videoUrl="https://www.youtube.com/embed/k2Dndf1lgXQ?autoplay=1"
        label="Calendar Tutorial"
      />
    </div>
  );
}

export default CalendarPage;
